import { Component, inject, PLATFORM_ID } from '@angular/core';
import { IconGlobeComponent } from '../icons/icon-globe/icon-globe.component';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {StorageService} from "../../../core/services/storage/storage.service";

@Component({
  selector: 'braidsbook-language-switcher',
  imports: [
    IconGlobeComponent,
    CdkMenu,
    CdkMenuTrigger,
    CommonModule,
    CdkMenuItem,
    TranslatePipe
  ],
  templateUrl: './language-switcher.component.html',
  styles: ``
})
export class LanguageSwitcherComponent {
  #translateService: TranslateService = inject(TranslateService);
  #storageService: StorageService = inject(StorageService);
  #platformId = inject(PLATFORM_ID);

  currentLanguage: string = this.#translateService.getCurrentLang();

  toggleLanguage(lang: 'en' | 'fr'): void {
    if (this.currentLanguage !== lang) {
      this.#storageService.setItem('USER_PREFERRED_LANGUAGE', lang);

      // window.location existe uniquement c\u00f4t\u00e9 client
      if (isPlatformBrowser(this.#platformId)) {
        window.location.reload();
      }
    }
  }

}
